import { CacheStrategy, DataSourceStrategy } from '@rammetec/data-access';
import { STOCK_MOVEMENT, StockMovementTypeValues, STOCK_MOVEMENT_TYPE_LABELS, } from '../types/stock-movement.js';
/**
 * Descriptor for StockMovement — read via `/pg/v1` + dynamic-query.
 * Writes go only through system-api `/stock` (ADR §D8).
 */
export const stockMovementDescriptor = {
    name: STOCK_MOVEMENT,
    label: 'Movimento de Estoque',
    domain: 'stock',
    collectionPath: 'org/{orgId}/stock-movement',
    pathPatternKeys: { orgId: 'string' },
    version: 2,
    description: 'Immutable stock ledger movement (append-only)',
    repositoryConfig: {
        dataSource: DataSourceStrategy.PostgresRest,
        cache: CacheStrategy.InMemory,
    },
    allowedDataSources: [DataSourceStrategy.PostgresRest],
    writePolicy: 'append-only',
    fields: [
        { name: 'id', label: 'ID', type: 'string', required: true },
        {
            name: 'movementDate',
            label: 'Data',
            type: 'date',
            required: true,
            description: 'Business date (may be retroactive)',
        },
        {
            name: 'type',
            label: 'Tipo',
            type: 'enum',
            required: true,
            enumValues: [...StockMovementTypeValues],
            enumLabels: STOCK_MOVEMENT_TYPE_LABELS,
        },
        { name: 'productId', label: 'Produto', type: 'string', required: true },
        { name: 'variantId', label: 'Variante', type: 'string', required: false },
        { name: 'lotId', label: 'Lote', type: 'string', required: false },
        { name: 'stockLocationId', label: 'Local', type: 'string', required: true },
        {
            name: 'ownerPartyId',
            label: 'Proprietário',
            type: 'string',
            required: false,
            description: 'FK → Party; null = estoque próprio (0044)',
        },
        {
            name: 'quantity',
            label: 'Quantidade',
            type: 'number',
            required: true,
            description: 'Signed quantity',
        },
        { name: 'unitCost', label: 'Custo unitário', type: 'number', required: false },
        { name: 'totalCost', label: 'Custo total', type: 'number', required: false },
        { name: 'sourceType', label: 'Origem (tipo)', type: 'string', required: false },
        { name: 'sourceId', label: 'Origem (id)', type: 'string', required: false },
        { name: 'reason', label: 'Motivo', type: 'string', required: false },
        {
            name: 'idempotencyKey',
            label: 'Chave de idempotência',
            type: 'string',
            required: true,
        },
        {
            name: 'reversedMovementId',
            label: 'Movimento estornado',
            type: 'string',
            required: false,
        },
        { name: 'createdBy', label: 'Criado por', type: 'string', required: false },
        { name: 'createdAt', label: 'Criado em', type: 'date', required: false },
        { name: 'deviceId', label: 'Dispositivo', type: 'string', required: false },
    ],
    foreignKeys: [
        {
            fieldName: 'productId',
            targetEntity: 'Product',
            relationship: 'many-to-one',
            displayField: 'description',
        },
        {
            fieldName: 'variantId',
            targetEntity: 'ProductVariant',
            relationship: 'many-to-one',
            displayField: 'description',
        },
        {
            fieldName: 'lotId',
            targetEntity: 'Lot',
            relationship: 'many-to-one',
            displayField: 'lotNumber',
        },
        {
            fieldName: 'stockLocationId',
            targetEntity: 'StockLocation',
            relationship: 'many-to-one',
            displayField: 'description',
        },
        {
            fieldName: 'ownerPartyId',
            targetEntity: 'Party',
            relationship: 'many-to-one',
            displayField: 'displayName',
        },
        {
            fieldName: 'reversedMovementId',
            targetEntity: 'StockMovement',
            relationship: 'many-to-one',
            displayField: 'id',
        },
    ],
};
//# sourceMappingURL=stock-movement.descriptor.js.map